import { AbstractControl } from '@angular/forms';

export function generateRandomString(length: number) {
  let result = '';
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  if (result.charCodeAt(0) > 47 && result.charCodeAt(0) < 58) {
    result = 'a' + result.slice(1);
  }
  return result;
}
export function transformFormInput(control: AbstractControl): void {
  let value = control.value;
  let transformedValue = '';
  const alphanumericRegex = /^[a-zA-Z0-9\s]*$/;

  for (let i = 0; i < value.length; i++) {
    if (value[i] !== ' ') {
      transformedValue +=
        i === 0 ? value[i].toUpperCase() : value[i].toLowerCase();
    }
  }

  // Update the form control value
  control.setValue(transformedValue);
}
